import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    mainContainer: {
        padding: theme.spacing(3),
    },
}));
export default useStyles;
